(function () {
  const announcement = document.querySelector('.announcement-bar-section');
  const headerSection = document.querySelector('.section-header');
  if (!announcement) return;

  function isMobile() {
    return window.matchMedia('(max-width: 999px)').matches;
  }

  function getAnnouncementMode() {
    if (announcement.querySelector('.announcement-bar--countdown')) return 'countdown';
    if (announcement.querySelector('.announcement-bar--scroll')) return 'scroll';
    if (document.body.classList.contains('announcement-bar-mode-countdown')) return 'countdown';
    return 'scroll';
  }

  function getDefaultHeight() {
    const mode = getAnnouncementMode();
    if (mode === 'countdown') return 56;
    return isMobile() ? 40 : 56;
  }

  function getAnnouncementContainer() {
    const mode = getAnnouncementMode();
    if (mode === 'countdown') {
      return announcement.querySelector('.countdown-announcement-bar__container');
    }
    return announcement.querySelector('.scroll-promotion-bar__container');
  }

  function measureHeight(element) {
    if (!element) return getDefaultHeight();
    return Math.ceil(element.getBoundingClientRect().height);
  }

  function setHeights() {
    const container = getAnnouncementContainer();
    const announcementHeight = measureHeight(container);

    document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
    document.documentElement.style.setProperty('--announcement-sticky-offset', `${announcementHeight}px`);

    if (headerSection) {
      const headerHeight = measureHeight(headerSection);
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
  }

  window.syncAnnouncementLayoutHeights = setHeights;

  document.body.classList.add('announcement-bar-fixed');

  setHeights();

  window.addEventListener('resize', setHeights);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(setHeights);
  }

  const announcementContainer = getAnnouncementContainer();
  if (announcementContainer && typeof ResizeObserver !== 'undefined') {
    const announcementObserver = new ResizeObserver(setHeights);
    announcementObserver.observe(announcementContainer);
  }

  if (headerSection && typeof ResizeObserver !== 'undefined') {
    const headerObserver = new ResizeObserver(setHeights);
    headerObserver.observe(headerSection);
  }
})();
